export const translations = {
 statusMaintenance: {
  CYCLIC: "Cíclico",
  DONE: "Hecho",
  DELETED: "Eliminado",
  EXPIRED: "Expirado",
  ON_HOLD: "En espera",
 },
};
